var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beePurple"},[_c('Header'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',[_c('section',{staticClass:"cont"},[_c('div',{staticClass:"bee-bg fx-align"},[_vm._v("敬请期待")]),_c('div',{staticClass:"btn-mint"},[_vm._v("MINT")]),_c('div',{staticClass:"num-cont fx-align"},[_c('span',{staticClass:"f-b"},[_vm._v("0")]),_vm._v("/666")])])])
}]

export { render, staticRenderFns }